export default "__VITE_ASSET__CVIxsbqM__"